<template>
  <div id="homePage">
    <el-container>
      <el-header>
        <div v-if="isShowHouse" class="curHouse">
          <div class="houseIcon"><i class="iconfont icon-fangzi"></i></div>
          <span class="houseName">{{ curHouseInfo.houseName }}</span>
        </div>
        <div v-for="(navItem, index) in navList" :key="index" class="btnCls">
          <router-link
            tag="span"
            :to="navItem.path"
            class="navBtnCls"
            active-class="selectedCls"
            >{{ navItem.name }}</router-link
          >
        </div>
      </el-header>
      <el-main class="contentCls">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import pathKey from "@/router/routerKey";
import { getStore, token_key } from "@/utils/localCache";
import mainStore from "@/store/storeMain";
import { mapGetters } from "vuex";

export default {
  name: "homePage",
  store: mainStore,
  data() {
    return {
      navList: [
        {
          name: "售后管理",
          isSelected: false,
          path: pathKey.afterSaleManagePath,
        },
        {
          name: "家庭状态",
          isSelected: true,
          path: pathKey.familyStatusPath,
        },
        {
          name: "信息维护",
          isSelected: false,
          path: pathKey.infoManagePath,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isShowHouse: "getShouldShowHouse",
      curHouseInfo: "getCurHouseInfo",
    }),
  },
  components: {},
  created() {
    // var token = getStore(token_key);
    // if (token == undefined) {
    //   this.$router.push('/login');
    // }
  },
  mounted() {},
  methods: {
    testAction(testItem) {
      testItem.isSelected = !testItem.isSelected;
    },
    messageAction() {
      this.$message({
        type: "success",
        message: "消息提示",
      });
    },
  },
};
</script>

<style scoped>
#homePage {
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/navBackImg.png");
}
.btnCls {
  height: 100%;
  width: 260px;
  display: inline-block;
  color: #d4f2ff;
}
.navBtnCls {
  width: 100%;
  height: 100%;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnCls:hover {
  cursor: pointer;
}
.selectedCls {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}
.contentCls {
  width: 100%;
  margin: 0px;
  padding: 0px;
  background-color: #f7f8fb;
}
.el-header {
  position: relative;
}
.curHouse {
  height: 100%;
  width: auto;
  position: absolute;
  left: 37px;
  display: flex;
  align-items: center;
}
.houseIcon {
  width: 37px;
  height: 37px;
  border-radius: 50%;
  background-color: white;
  overflow: hidden;
  line-height: 37px;
  padding-top: 3px;
  box-sizing: border-box;
}
.houseIcon i {
  width: 30px;
  height: 30px;
  font-size: 30px;
  color: #1aadfb;
}
.houseName {
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homePage.vue